import { Box, Button } from "@mui/material";
import { ButtonStyles } from "../../styles/commonStyles";

const SubmitButton = ({ label, icon: Icon, disabled, color }) => (
  <Box display="flex" width="100%" justifyContent="end" mt={4}>
    <Button
      variant="contained"
      startIcon={Icon}
      type="submit"
      sx={ButtonStyles}
      disabled={disabled}
      color={color}
    >
      {label}
    </Button>
  </Box>
);

export default SubmitButton;
